module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Extended-Medium.3be5a0b0.woff2";